import Vue from 'vue'
import OrI18n from '@onereach/or-i18n'

import config from '../config'
import router from '../router/router'
import en from './locales/en.json'

/**
 * Get Messages JSON By Locale
 * @async
 * @param {String} locale 'en', 'fr', etc.
 * @returns {Promise<{}>} messages JSON
 */
function getLocaleMessagesAsync (locale) {
  return import(/* webpackChunkName: "locale/[request]" */ `./locales/${locale}`).then(mod => mod.default)
}

const orI18n = new OrI18n({
  vueConstructor: Vue,
  router,
  orConfig: config, // { COOKIE_DOMAIN, COOKIE_NAME, COOKIE_NAME_PREFIX, SUPPORTED_LOCALES }
  messages: { en }, // only locales that should be bundled (fallback)
  getLocaleMessagesAsync
})

export const i18n = orI18n.i18n

export default orI18n
